import { SimpleHandlerConfig } from '../types';
import { GenericStreamHandler } from './GenericStream';

/**
 * A handler to play RTSP/RTP stream directly from a `HTMLVideoElement`
 */
export class RtspNativeStreamHandler extends GenericStreamHandler {
    protected _type: string;
    protected _videoId: string;

    constructor(config: SimpleHandlerConfig) {
        super(config);
        this._videoId = config.videoUrl;
        this._videoUrl = config.videoUrl;
        this._type = 'rtsp_native';
    }
}
